import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { SuperRichEditComponent, TranslateService } from '@devinforius/super-compos-17';
import { DocumentFormatApi } from 'devexpress-richedit/lib/model-api/formats/enum';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/core/services/api.service';
import { IDelibeGlobalService } from 'src/app/core/services/idelibe/global.service';
import { ContentEditor } from 'src/app/shared/models/content-editor';
import { TemplateFusionChamps } from 'src/app/shared/models/global/template-fusion-champs';
import { IAppConfiguration } from 'src/app/shared/models/response/IAppConfiguration';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent implements OnInit {
  private readonly spinner: NgxSpinnerService = inject(NgxSpinnerService);
  private readonly api: ApiService = inject(ApiService);
  private readonly toastr: ToastrService = inject(ToastrService);
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly iDelibeGlobalService: IDelibeGlobalService = inject(IDelibeGlobalService);

  @Input() showAllAccordion: boolean = false;
  @Input() pointId: number;
  @Input() globalElements;
  @Input() activeState: boolean[] = [true, false, false, false, false];

  @ViewChild('document_editor_motivation') public document_editor_motivation: SuperRichEditComponent; //ViewChild of the Motivation part of the accordion
  @ViewChild('document_editor_decision') public document_editor_decision: SuperRichEditComponent; //ViewChild of the part of Decision the accordion
  @ViewChild('document_editor_observation') public document_editor_observation: SuperRichEditComponent; //ViewChild of the Observation part of the accordion
  @ViewChild('document_editor_complementDeDeliberation') public document_editor_complementDeDeliberation: SuperRichEditComponent; //ViewChild of the Complement de deliberation part of the accordion
  @ViewChild('document_editor_notesDeSynthese') public document_editor_notesDeSynthese: SuperRichEditComponent; //ViewChild of the Notes de synthèses part of the accordion

  public selectedType: string = '';
  public currentIndex: number = 0;
  public contenuStaticRTFFilesPresents;
  languageRichEdit: string;
  public contentEditors: ContentEditor[] = [
    { Motivation: null },
    { Decision: null },
    { Observations: null },
    { ComplementDeDeliberation: null },
    { NotesDeSynthese: null },
  ]; //* contains the datas of each editor
  public fusions: TemplateFusionChamps;
  public config: IAppConfiguration;

  public ngOnInit(): void {
    const language = JSON.parse(sessionStorage.getItem('langue'));
    this.languageRichEdit = language.codeLangue.toLowerCase();
    this.getFusionsField();
    this.getGlobalConfig();
    this.reloadRTFPresence();
  }

  onShowAll(): void {
    this.spinner.show();
    setTimeout(() => {
      this.showAllAccordion = !this.showAllAccordion;
      const arrayRTF = ['Motivation', 'Decision', 'Observations', 'ComplementDeDeliberation', 'NotesDeSynthese'];
      if (this.showAllAccordion) {
        //Quand on va ouvrir les accordéons
        arrayRTF.map((type, index) => {
          this.activeState[index] = true;
          this.loadFile(type);
        });
        this.spinner.hide();
      } else {
        arrayRTF.map((_, index) => {
          this.activeState[index] = false;
        });
        this.spinner.hide();
      }
    }, 100);
  }

  handleClick(event: Event): void {
    event.stopPropagation();
  }

  getFusionsField(): void {
    this.iDelibeGlobalService.getGlobalFusionsFields().subscribe((res: TemplateFusionChamps) => {
      this.fusions = res;
    });
  }

  getGlobalConfig(): void {
    this.iDelibeGlobalService.getConfiguration().subscribe((config: IAppConfiguration) => {
      this.config = config;
    });
  }

    //* triggers when the user saves an editor (for example on the save button for Motivation)
  submitAContent(event, typeRTF: string): void {
    this.spinner.show();
    //TODO faire pareil pour les versions dynamiques!
    const type = typeRTF;
    const content = event;
    const blob = new Blob([content], { type: 'application/rtf' });
    this.api.putOnePointRTFDatasStatic(this.pointId, blob, type).subscribe(() => {
      this.toastr.success(this.translate.translate('message.success.dataSaved'));
      this.reloadRTFPresence();
      this.spinner.hide();
    });
  }

    //* Getting the datas for each RTF
  getMotivation($event: Blob): void {
    const blob = new Blob([$event], { type: 'application/rtf' });
    const data = {
      Motivation: blob,
    };
    this.contentEditors.splice(0, 1, data);
  }
  getDecision($event: Blob): void {
    const blob = new Blob([$event], { type: 'application/rtf' });
    const data = {
      Decision: blob,
    };
    this.contentEditors.splice(1, 1, data);
  }
  getObservations($event: Blob): void {
    const blob = new Blob([$event], { type: 'application/rtf' });
    const data = {
      Observations: blob,
    };
    this.contentEditors.splice(2, 1, data);
  }
  getComplement($event: Blob): void {
    const blob = new Blob([$event], { type: 'application/rtf' });
    const data = {
      ComplementDeDeliberation: blob,
    };
    this.contentEditors.splice(3, 1, data);
  }

  //* triggers when a RTF is loaded
    loadFile(type: string): void {
      if (this.pointId) {
        this.spinner.show();
        this.api.getPointRTFDatasStatic(this.pointId, type).subscribe((res: Blob) => {
          if (res && res.size > 0) {
            if (type === 'Motivation' && this.document_editor_motivation) {
              setTimeout(() => {
                this.document_editor_motivation.rich.openDocument(res, type, DocumentFormatApi.Rtf, (loaded) => {
                  if (loaded) {
                    this.spinner.hide();
                  } else {
                    this.activeState[this.currentIndex] = false;
                    this.spinner.hide();
                    this.toastr.error(this.translate.translate('error.cannotGetRTFFile'));
                  }
                });
              }, 1000);
            }
            if (type === 'Decision' && this.document_editor_decision) {
              this.document_editor_decision.rich.openDocument(res, 'Decision', DocumentFormatApi.Rtf, (loaded) => {
                if (loaded) {
                  this.spinner.hide();
                } else {
                  this.activeState[this.currentIndex] = false;
                  this.spinner.hide();
                  this.toastr.error(this.translate.translate('error.cannotGetRTFFile'));
                }
              });
            }
            if (type === 'Observations' && this.document_editor_observation) {
              this.document_editor_observation.rich.openDocument(res, 'Observations', DocumentFormatApi.Rtf, (loaded) => {
                if (loaded) {
                  this.spinner.hide();
                } else {
                  this.activeState[this.currentIndex] = false;
                  this.spinner.hide();
                  this.toastr.error(this.translate.translate('error.cannotGetRTFFile'));
                }
              });
            }
            if (type === 'ComplementDeDeliberation' && this.document_editor_complementDeDeliberation) {
              this.document_editor_complementDeDeliberation.rich.openDocument(
                res,
                'ComplementDeDeliberation',
                DocumentFormatApi.Rtf,
                (loaded) => {
                  if (loaded) {
                    this.spinner.hide();
                  } else {
                    this.activeState[this.currentIndex] = false;
                    this.spinner.hide();
                    this.toastr.error(this.translate.translate('error.cannotGetRTFFile'));
                  }
                }
              );
            }
            if (type === 'NotesDeSynthese' && this.document_editor_notesDeSynthese) {
              this.document_editor_notesDeSynthese.rich.openDocument(
                res,
                'NotesDeSynthese',
                DocumentFormatApi.Rtf,
                (loaded) => {
                  if (loaded) {
                    this.spinner.hide();
                  } else {
                    this.activeState[this.currentIndex] = false;
                    this.spinner.hide();
                    this.toastr.error(this.translate.translate('error.cannotGetRTFFile'));
                  }
                }
              );
            }
          } else {
            this.spinner.hide();
          }
        });
      }
    }

    //* triggers when the user clicks on a accordion
  onClick(type: string, index: number): void {
    this.selectedType = type;
    this.currentIndex = index;
    //on ne va charger que 1 RTF a la fois et on ne l'ouvre que si l'accordéon s'ouvre
    if (this.activeState[index] === true) {
      this.loadFile(this.selectedType);
    }
  }

    // Triggers when a RTF needs to be reloaded
  reloadRTF(event: Event, type: string, index: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.selectedType = type;
    this.currentIndex = index;
    this.reloadRTFPresence();
  }

    //* reloads the datas that displays if a RTF has data sin it
  reloadRTFPresence(goToNextStep: boolean = false): void {
    this.api.getPointContenuStaticRTFFilesPresents(this.pointId).subscribe((res) => {
      this.contenuStaticRTFFilesPresents = res;
      if (goToNextStep) {
        this.spinner.hide();
      }
    });
  }

    //* Opens the editor on full screen in another navigator tab
  openFullScreen(event: Event, title: string): void {
    event.preventDefault();
    event.stopPropagation();
    const config = JSON.parse(sessionStorage.getItem('globalConfig'));
    window.open(config.baseUrl + `/private/editor/point/` + this.pointId + `/` + title);
  }

  getNotes($event: Blob): void {
    const blob = new Blob([$event], { type: 'application/rtf' });
    const data = {
      NotesDeSynthese: blob,
    };
    this.contentEditors.splice(4, 1, data);
  }
}
